import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class GenericDrawerService {
  data: any = null;
  showDrawer: boolean = false;
  component: any = null;

  componentChanged: Subject<any> = new Subject<any>();
  closeDrawer$: Subject<any> = new Subject<any>();

  constructor() {}

  changeComponent(component, data = {}) {
    this.showDrawer = true;
    this.component = component;
    this.data = data;

    this.componentChanged.next(null);
  }
}
